"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEscapeClasses = exports.getFromTheme = void 0;

var get_from_theme_1 = require("./get-from-theme");

Object.defineProperty(exports, "getFromTheme", {
  enumerable: true,
  get: function get() {
    return get_from_theme_1.getFromTheme;
  }
});

var use_escape_classes_1 = require("./use-escape-classes");

Object.defineProperty(exports, "useEscapeClasses", {
  enumerable: true,
  get: function get() {
    return use_escape_classes_1.useEscapeClasses;
  }
});